import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from './token.service';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_STORAGE } from '../constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from './notification.service';
import { ApiService } from './api.service';
import { ThemeService } from './themes.service';
import { CookieConsentService } from './cookie-consent.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
    providedIn: 'root'
})

export class RouteGuard implements CanActivate {

    selectedRegion: any;
    setHomepage = environment.HOMEPAGE;

    constructor(
        private router: Router,
        private cookieService: CookieService,
        private themeService: ThemeService,
        private apiService: ApiService,
        private consentService: CookieConsentService,
        private spinnerService: NgxSpinnerService,
    ) { }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            this.spinnerService.show();

            let ipAddressResponse: any;
            if (environment.GET_IP_ADDRESS) {
                if (!this.apiService.ipAddress) {
                    ipAddressResponse = await this.apiService.getIpAddress();
                    if (ipAddressResponse) {
                        this.apiService.ipAddress = ipAddressResponse.origin;
                        this.apiService.systemInformation.ipAddress = this.apiService.ipAddress;
                    }
                }
            }

            this.themeService.selectedRegion$.subscribe((response) => {
                this.selectedRegion = response;
            });

            let givenConsent: any;
            const storedConsent = this.cookieService.get(`${COOKIE_STORAGE.COOKIE_CONSENT}-${this.selectedRegion}`);
            if (storedConsent) {
                givenConsent = this.consentService.sanitizeCookieValue(storedConsent);
            }

            if (givenConsent && givenConsent?.consent) {
                if ((this.apiService.ipAddress || COOKIE_STORAGE.LOCAL_IP_ADDRESS) === givenConsent?.ip) {
                    this.spinnerService.hide();
                    return true;
                } else {
                    this.consentService.cookieConsentErrorSubject.next({
                        type: 'warning',
                        message: "please allow necessary cookies to continue exploring",
                    });

                    this.router.navigate(['/', this.setHomepage]);
                    this.consentService.isCookiesConsentHiddenSubject.next(false);
                    this.consentService.focusAllowCookiesButtonSubject.next(true);
                    this.spinnerService.hide();
                    return false;
                }
            } else {
                this.consentService.showCookieConsentSubject.next(true);
                this.consentService.isCookiesConsentHiddenSubject.next(false);
                this.consentService.isAllCookiesAllowedSubject.next(false);
                this.router.navigate(['/', this.setHomepage]);

                this.consentService.cookieConsentErrorSubject.next({
                    type: 'warning',
                    message: "please allow necessary cookies to continue exploring",
                });

                this.consentService.openCookieSettingsComponent(
                    givenConsent?.necessary_cookies_consent,
                    givenConsent?.performance_cookies_consent,
                    givenConsent?.marketing_cookies_consent,
                    givenConsent?.analytical_cookies_consent,
                    givenConsent?.functional_cookies_consent,
                );

                this.spinnerService.hide();
                return false;
            }
        } catch (error) {
            this.spinnerService.hide();
            return false;
        }
    }
}